import React, { FC } from 'react';
import { WarningWithTriangle } from '@td-client-frontend/icons';

interface FieldWarningWithIconProps {
  iconClasses?: string;
  message?: string;
}

export const FieldWarningWithIcon: FC<FieldWarningWithIconProps> = ({ iconClasses = '', message = '' }) => {
  return (
    <span className='flex items-center gap-2' data-testid='field-warning-with-icon'>
      <span className={iconClasses}>
        <WarningWithTriangle />
      </span>
      <span className='text-lg text-black'>{message}</span>
    </span>
  );
};
